var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 207,
    viewBox: "0 0 483 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 379.5,
    cy: 34.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 34.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.5,
    cy: 103.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.5,
    cy: 103.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.5,
    cy: 103.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 103.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 103.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.5,
    cy: 172.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.5,
    cy: 172.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.5,
    cy: 172.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 172.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 172.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 172.5,
    r: 34.5,
    fill: "#FFE062"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 172.5,
    r: 34.5,
    fill: "#FFE062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.5286e758c3f2b8ddcea95aeb7bd716ef.svg";
export { ForwardRef as ReactComponent };